import { Link } from "react-router-dom";
import { accentFor } from "@/lib/verticals";

export function CategoryPill({ category, testid, className = "" }) {
  const accent = accentFor(category);
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest px-3 py-1.5 ${className}`}
      style={{ backgroundColor: `${accent.color}14`, color: accent.color }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: accent.color }} />
      {category}
    </span>
  );
}

export function SectionHeading({ overline, title, className = "", light = false }) {
  return (
    <div className={className}>
      {overline && <p className={`overline mb-4 ${light ? "text-white/50" : "text-restrained-blue"}`}>{overline}</p>}
      <h2 className={`font-serif text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05] ${light ? "text-white" : "text-deep-navy"}`}>
        {title}
      </h2>
    </div>
  );
}

export function TextLink({ to, children, testid, light = false }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`group inline-flex items-center gap-2 text-sm border-b pb-1 transition-colors ${
        light ? "text-white border-white/30 hover:border-white" : "text-deep-navy border-deep-navy/30 hover:border-restrained-blue hover:text-restrained-blue"
      }`}
    >
      {children}
      <span className="transition-transform group-hover:translate-x-1">→</span>
    </Link>
  );
}
